
import { Injectable } from '@angular/core';
import { Router, CanActivate } from '@angular/router';
import { user_local } from '../Models/local_user';
import { AuthConfig ,JwtHelper  } from 'angular2-jwt/angular2-jwt';

@Injectable()
export class AuthoService {
  user: string;
  constructor(private router:Router) {
  
   }
  canActivate(){
    this.user=localStorage.getItem('user_id');
     if(this.user){
       console.log('active');
       return true;
     }
     else{
       console.log('not active');
       this.router.navigate(['/login']);
       return false;
     }
  }

}



// WEBPACK FOOTER //
// D:/xampp/htdocs/playitadmin_frontend/src/app/Services/autho.service.ts